import xhr from 'Common/utils/xhr'
import { foldersEndpoint } from './endpoints'

/**
 * Create a folder
 * @param {Object} config
 * @param {string} [config.name=null] - The name of the new folder; endpoint returns 'Untitled Folder' by default
 * @param {string} [config.description=null] - The folder description; endpoint returns null by default
 * @param {(Object|Boolean)} [config.item=false] - A folder item object to instantiate the folder with
 */
const createFolder = ({ name = null, description = null, item = false } = {}) =>
  xhr({
    url: foldersEndpoint,
    method: 'POST',
    data: {
      folder: {
        name,
        description,
        ...(item && {
          folder_items_attributes: [
            {
              fileable_id: item.fileable.id,
              fileable_type: item.fileable.type,
            },
          ],
        }),
      },
    },
  })

export default createFolder
